export var Maps;
(function (Maps) {
    function getOrElseUpdate(map, key, defaultValue) {
        const value = map.get(key);
        if (value !== undefined) {
            return value;
        }
        else {
            const newValue = defaultValue();
            map.set(key, newValue);
            return newValue;
        }
    }
    Maps.getOrElseUpdate = getOrElseUpdate;
})(Maps || (Maps = {}));
export var Arrays;
(function (Arrays) {
    function groupBy(values, by, convertValue) {
        const convert = !!convertValue
            ? convertValue
            : (vs) => vs;
        return Array
            .from(values.reduce((agg, current) => {
            const key = by(current);
            const existing = agg.get(key);
            if (existing !== undefined) {
                existing.push(current);
            }
            else {
                agg.set(key, [current]);
            }
            return agg;
        }, new Map()).entries())
            .map(([k, vs]) => [k, convert(vs)]);
    }
    Arrays.groupBy = groupBy;
    function range(start, end, increment = 1) {
        const length = Math.abs((end - start) / (increment || 1));
        return Array.from({ length }, (v, i) => start + increment * i);
    }
    Arrays.range = range;
    function nonEmpty(values) {
        return values
            .filter(v => v != undefined)
            .map(v => v);
    }
    Arrays.nonEmpty = nonEmpty;
    function sorted(values, ascending = true, extractor) {
        const compareFn = ((v1, v2) => {
            const a = extractor ? extractor(v1) : v1;
            const b = extractor ? extractor(v2) : v2;
            if (a === b)
                return 0;
            if (a == null)
                return -1;
            if (b == null)
                return 1;
            return a < b ? -1 : 1;
        });
        return [...values].sort((v1, v2) => {
            const asc = compareFn(v1, v2);
            return ascending ? asc : -asc;
        });
    }
    Arrays.sorted = sorted;
    function zip(a, b) {
        const zip = [];
        const length = Math.max(a.length, b.length);
        for (let i = 0; i < length; ++i) {
            zip[i] = [a[i], b[i]];
        }
        return zip;
    }
    Arrays.zip = zip;
    function unique(values) {
        const set = new Set(values);
        return Array.from(set);
    }
    Arrays.unique = unique;
    function partition(values, p) {
        return values.reduce(([m, n], v) => p(v) ? [[...m, v], n] : [m, [...n, v]], [[], []]);
    }
    Arrays.partition = partition;
})(Arrays || (Arrays = {}));
//# sourceMappingURL=collections.js.map